/**
 * 注文詳細ページへのパス。画面に出す注文番号をそのまま識別子にする。
 * `#`はURLのフラグメント区切りなのでエンコードして載せる
 */
export const toPurchaseHistoryOrderPath = (orderNumber: string): string =>
  `/account/settlement/history/${encodeURIComponent(orderNumber)}`;

/**
 * ルートパラメータから注文番号を取り出す。
 * react-router 5はパラメータをデコードしない（`%23`が残る）ため、ここでデコードする。
 * 不正なエンコードのURLはhistoryがアプリ起動時に例外を投げるので、ここまで届かない
 */
export const decodePurchaseHistoryOrderNumber = (parameter: string): string =>
  decodeURIComponent(parameter);
